enum MetodoPagamentoEnum {
  Pix = 'Pix',
  Boleto = 'Boleto',
  CartaoDeCredito = 'CartaoDeCredito',
  Debito = 'Debito',
  Financiamento = 'Financiamento',
}

export default MetodoPagamentoEnum
